import React, { Component } from 'react';
import Stripe from '../../shared/stripe/Stripe';
import Payment from './Payment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class Index extends Component {
  componentDidMount() {
    const { isPremium, router: { push } } = this.props;

    if (isPremium) {
      push('/reps/calendar');
    }
  }

  render() {
    return (
      <Stripe>
        <Payment  />
      </Stripe>
    );
  }
}

Index.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

const mapStateToProps = (state) => {
  return {
    isPremium: state.getIn(['currentUser', 'data', 'premium'])
  };
};

export default connect(mapStateToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/reps/premium/Index.jsx